// Tamanho das páginas em mm
exports.formats = {
  "A0": { width: 841, height: 1189 },
  "A1": { width: 594, height: 841 },
  "A2": { width: 420, height: 594 },
  "A3": { width: 297, height: 420 },
  "A4": { width: 210, height: 297 },
  "A5": { width: 148, height: 210 },
  "A6": { width: 105, height: 148 },
  "A7": { width: 74, height: 105 },
  "A8": { width: 52, height: 74 },
  "A9": { width: 37, height: 52 },
  "A10": { width: 26, height: 37 },
  "B0": { width: 1000, height: 1414 },
  "B1": { width: 707, height: 1000 },
  "B2": { width: 500, height: 707 },
  "B3": { width: 353, height: 500 },
  "B4": { width: 250, height: 353 },
  "B5": { width: 176, height: 250 },
  "B6": { width: 125, height: 176 },
  "B7": { width: 88, height: 125 },
  "B8": { width: 62, height: 88 },
  "B9": { width: 44, height: 62 },
  "B10": { width: 31, height: 44 },
  "C0": { width: 917, height: 1297 },
  "C1": { width: 648, height: 917 },
  "C2": { width: 458, height: 648 },
  "C3": { width: 324, height: 458 },
  "C4": { width: 229, height: 324 },
  "C5": { width: 162, height: 229 },
  "C6": { width: 114, height: 162 },
  "C7": { width: 81, height: 114 },
  "C8": { width: 57, height: 81 },
  "C9": { width: 40, height: 57 },
  "C10": { width: 28, height: 40 },
  "Comm10E": { width: 105, height: 241 },
  "DLE": { width: 110, height: 220 },
  "Executive": { width: 184, height: 267 },
  "Folio": { width: 210, height: 330 },
  "Ledger": { width: 432, height: 279 },
  "Legal": { width: 216, height: 356 },
  "Letter": { width: 216, height: 279 },
  "Tabloid": { width: 279, height: 432 }
}

// Layout do papel
exports.layouts = {
  "portrait": "Retrato",
  "landscape": "Paisagem"
}


// WEBPACK FOOTER //
// ./functions/shared/paperConfig.js